import { Box } from '@chakra-ui/react'
import Image from 'next/image'

const Testimony = () => {
  return (
    <Box w="100%" h="100%">
      <Image
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/s1-1737465934584.jpg"
        alt="five tumbler"
        width={1260}
        height={601}
        className="w-full h-full object-cover"
      />
    </Box>
  )
}

export default Testimony
